import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { utility } from '../common/utility';

@Injectable({
  providedIn: 'root'
})

export class ReportService {

  baseUrl: string;
  
  constructor(private http: HttpClient) {
  }
  
  public GetMemberReport(reportParamModel: Map<string, string>){
    
    this.baseUrl = environment.apiBase.concat("Reports/GetMemberReport");      
    let queryParams = new HttpParams();
    for (let entry of reportParamModel.entries())
    {
      queryParams = queryParams.append(entry[0], entry[1]);
    }        

    let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.http.get<any>(this.baseUrl, {params:queryParams, responseType:'blob' as 'json', headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })}).pipe(catchError(utility.handleError<any[]>('GetMemberReport', [])));
  }
 
}
